import $ from '@sparta.global.vendors/jquery';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import workflowUtility from '@sparta.digital-mortgage-application.utilities/workflow-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';

const Template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "\r\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.digital-mortgage-application.modules/dma-tag-manager-module",
  "version": "2.0.1",
  "id": "dmaTagManagerModule",
  "containerID": "digitalMortgageApplicationDmaTagManagerModule",
  "moduleName": "digital-mortgage-application-dma-tag-manager-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "dma-tag-manager-module",
  "data": {
    "init": "dmaTagManagerModuleJS",
    "options": {
      "var2": 3
    }
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.digital-mortgage-application.utilities/workflow-utility": "^2.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1"
  },
  "stores": []
};

/* globals bactm */
/* eslint max-len: ["error", 150] */

/*
 * dma-tag-manager-module
 * module_js_id: dmaTagManagerModuleJS
 *
 * Copyright (c) 2017-12-3 nbdzrui
 */

function onMount($module, dispatch, getState) {
  const {
    dataReceived
  } = getState();
  const {
    isAuthenticated,
    flowSelection
  } = dataReceived;
  const route = workflowUtility.getCurrentRoute();
  let tagManagerConfig = {};
  if (route.modules && route.modules['dma-tag-manager-module']) {
    tagManagerConfig = route.modules['dma-tag-manager-module'];
  }
  const authTagManager = tagManagerConfig.bactm_auth || [];
  const unAuthTagManager = tagManagerConfig.bactm_unAuth || [];
  const authPageID = authTagManager.length ? authTagManager[0] : '';
  const authOptions = authTagManager.length > 1 ? authTagManager[1] : {};
  const unAuthPageID = unAuthTagManager.length ? unAuthTagManager[0] : '';
  const unAuthOptions = unAuthTagManager.length > 1 ? unAuthTagManager[1] : {};
  const {
    offRampCode,
    applicationId
  } = dataReceived;
  if (!authOptions.segmentValues) {
    authOptions.segmentValues = [];
  }
  if (!unAuthOptions.segmentValues) {
    unAuthOptions.segmentValues = [];
  }
  if (offRampCode) {
    authOptions.segmentValues[0] = authOptions.segmentValues[0].replace('ORCode', offRampCode);
    unAuthOptions.segmentValues[0] = unAuthOptions.segmentValues[0].replace('ORCode', offRampCode);

    // add additional category for Only welcomeback flow
    // flowSelection will be null for all other flows
    if (flowSelection) {
      let addlCategoryIndex;
      if (flowSelection === 'DMPA') {
        const isWelcomeBack = window.location.href.indexOf('/welcomeback/') > -1;
        const isPrequal = window.location.href.indexOf('/prequal/') > -1;
        if (isPrequal) {
          addlCategoryIndex = 0;
        } else if (isWelcomeBack) {
          addlCategoryIndex = 1;
        }
      } else if (flowSelection === 'DMPQUPDATE') {
        addlCategoryIndex = 2;
      } else if (flowSelection === 'CONVERTTODMA') {
        addlCategoryIndex = 3;
      }
      authOptions.addlCategoryIndex = addlCategoryIndex;
      unAuthOptions.addlCategoryIndex = addlCategoryIndex;
    }
  }
  if (applicationId) {
    if (authTagManager.length > 1 && unAuthTagManager.length > 1) {
      if (authTagManager[1].applicationId && unAuthTagManager[1].applicationId) {
        authOptions.applicationId = authOptions.applicationId.replace('stringValue', applicationId);
        unAuthOptions.applicationId = unAuthOptions.applicationId.replace('stringValue', applicationId);
      }
    }
  }
  if (applicationId) {
    authOptions.segmentValues.push(`dmaAppID_${applicationId}`);
    unAuthOptions.segmentValues.push(`dmaAppID_${applicationId}`);
  }
  const cookies = document.cookie.split(';');
  let sid;
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].split('=');
    if (cookie[0] === 'SID' || cookie[0] === ' SID') {
      sid = cookie[1];
    }
  }
  if (sid) {
    authOptions.segmentValues.push(`dmaSID_${sid}`);
    unAuthOptions.segmentValues.push(`dmaSID_${sid}`);
  }
  if (dataReceived.returnStep) {
    if (dataReceived.returnStep.toLowerCase() === route.routeName) {
      authOptions.saveAndReturnId = applicationId;
      unAuthOptions.saveAndReturnId = applicationId;
    }
    authOptions.isSaveAndReturn = true;
    unAuthOptions.isSaveAndReturn = true;
  }
  let timer;
  function initialTrackingEvents() {
    if (typeof bactm.pageview === 'function') {
      if (isAuthenticated && authTagManager && authPageID !== '') {
        bactm.pageview(authPageID, authOptions);
      } else if (unAuthTagManager && unAuthPageID !== '') {
        bactm.pageview(unAuthPageID, unAuthOptions);
      }
      try {
        bactm.rescanDOM();
      } catch (e) {
        console.log(`rescan dom cm function failure ${e}`);
      }
      clearInterval(timer);
    }
  }
  timer = setInterval(initialTrackingEvents, 2000);
}
onMount.oncePerRoute = true;
function initPageViewStub() {
  if (typeof window.bactm === 'undefined') {
    window.bactm = {};
    window.bactm.pageview = function (o, n) {
      window.dataCollector = window.dataCollector || [];
      window.dataCollector.push({
        event: 'pageview',
        pageInfoKey: o,
        options: n
      });
    };
    window.bactm.log = function (t) {
      window.dataCollector = window.dataCollector || [];
      if (!(Array.isArray() || typeof t !== 'object' || 'ts' in t)) {
        const now = new Date();
        t.ts = now.getTime() - now.getTimezoneOffset(); // eslint-disable-line no-param-reassign
      }
      window.dataCollector.push({
        event: 'log',
        data: t
      });
    };
    window.bactm.impressions = function () {
      window.bactm_fireImpressions = true;
    };
  }
}
class dmaTagManagerModuleJS extends Module {
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.$target = $('.dma-tag-manager-module');
  }
  init() {
    initPageViewStub();
    workflowUtility.dispatch(workflowUtility.actions.initModule(this.$target, {
      onMount
    }));
  }
}
/* istanbul ignore next */

registerModuleClass({
  moduleClass: dmaTagManagerModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { dmaTagManagerModuleJS as default, moduleConfig };
